/*
----------------------------
Module - form
----------------------------
*/

import { setTimeout } from 'core-js';
import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';


    fmg.setHighlightedItem = function(prevIndex, newIndex) {
        if(prevIndex >= 0) {
          var $prevSelectedItem = $("#address-option-" + prevIndex);
          $prevSelectedItem.removeClass("highlighted-option");
        }
        
        if (newIndex >= 0) {
          var $selectedItem = $("#address-option-" + newIndex);
          $selectedItem.addClass("highlighted-option");
          $selectedItem.parent().siblings("input").attr("aria-activedescendant", $selectedItem.attr("id"));
        }
    }
    
    fmg.setSelectedItem = function(addressField, selectedIndex) {
        if (selectedIndex >= 0) {
          var selectedItem = "#address-option-" + selectedIndex;
          addressField.val($(selectedItem).text());
        }
        addressField.attr("aria-activedescendant", "");
        addressField.parent().parent().siblings(".address-validation").find("input[value='0']").prop("checked", true);
    }
    
    fmg.resetAddressSuggestions = function(hideUseThisAddress = true, resetUseThisAddressTicked = true, resetAddressValidation = true, delayHideUseThisAddress = false) {
        
        var $listbox = $("body").find(".listbox");
        var $use_this_address = $("body").find(".no-result--address-suggestion");
        var $address_validation = $("body").find(".address-validation");
        
        $listbox.addClass("hidden");
        $listbox.empty();
        $listbox.attr("data-last-result-index", "");
        
        if( hideUseThisAddress) {
            if(delayHideUseThisAddress) {
                setTimeout(() => { $use_this_address.addClass("hidden"); }, 1000);
            } else {
            $use_this_address.addClass("hidden");
            }
        }
        
        if(resetUseThisAddressTicked) {
            $use_this_address.find("input").prop("checked", false);
        }

        if (resetAddressValidation) {
            $address_validation.find("input[value='0']").prop("checked", false);
            $address_validation.find("input[value='1']").prop("checked", false);
        }
        
    }
    
    fmg.getAddressSuggestions = function() {
        
        var $listbox = $("body").find(".listbox");
        var $use_this_address = $("body").find(".no-result--address-suggestion");
        
        var searchAddressEndpoint = $(this).data("field-address-search-endpoint");
        var partialAddress = $(this).val();
        var searchParameter = "&searchFor=" + partialAddress;

        fmg.resetAddressSuggestions();

        if(partialAddress.length > 2) {
            $.ajax({
                type: "GET",
                url: searchAddressEndpoint + searchParameter,                
                
                success: function(response) {
                    if (!fmg.isAddressValidated()) {
                        fmg.resetAddressSuggestions();
                            
                        if(response !== null) {
                            
                            try {
                                var results = JSON.parse(response).AddressSuggestion;
                                $listbox.removeClass("hidden");
                                var lastResultIndex = results.length - 1;
                                $listbox.attr("data-last-result-index", lastResultIndex);
                                    
                                $.each(results, function(index, value) {
                                    $listbox.append($("<li></li>")
                                    .addClass("addressSuggestion")
                                    .attr("id", "address-option-" + index)
                                    .attr("role", "option")
                                    .text(value.FullAddress));
                                });
                                    
                                // set aria-expanded to true for div role combobox
                                $listbox.parent().attr("aria-expanded", "true");
                            }
                            catch(error) {
                                fmg.resetAddressSuggestions();
                                $use_this_address.removeClass("hidden");
                            }
                        }
                    }
                },
                
                error: function(response) {
                    if (!fmg.isAddressValidated()) {
                        fmg.resetAddressSuggestions();
                        $use_this_address.removeClass("hidden");
                    }
                }
            })
        }
    }
    
    fmg.isAddressValidated = function() {
        var isValid = $("body").find(".address-validation").find("input[value='0']").prop("checked");
        var isInvalid = $("body").find(".address-validation").find("input[value='1']").prop("checked");

        return isValid || isInvalid;            
    }

    fmg.populateEquineDetails = function(equineDetails, $wrapper = $("body")) {

        var accountNumber = equineDetails.AccountNumber;
        var accountName = equineDetails.AccountName.trim();
        var email = equineDetails.PrimaryEmail.trim();
        var policyNumber = equineDetails.PolicyNumber;
        var numberOfHorses = equineDetails.NumberOfHorses;
        var renewalDate = equineDetails.RenewalDate.trim();

        // populate account details
        $wrapper.find("#q10985_q1").val(accountNumber);
        $wrapper.find("#q10985_q2").val(accountName);
        $wrapper.find("#q10985_q3").val(policyNumber);
        $wrapper.find("#q10985_q4").val(email);
        $wrapper.find("#q10985_q6").val(renewalDate);
        $wrapper.find("#q10985_q6").blur();

        //set number of horses
        $wrapper.find("#q10985_q5").val(numberOfHorses).change();

        fmg.populateHorses(equineDetails);

        fmg.clearBrowserAutoFill();

    }

    fmg.populateHorses = function(equineDetails, $wrapper = $("body")) {
        
        var numberOfHorses = equineDetails.NumberOfHorses;
        var horses = equineDetails.Horses;

        // horses details
        var horse1Name = "";
        var horse1Use = "";
        var horse1SumInsured = "";
        
        var horse2Name = "";
        var horse2Use = "";
        var horse2SumInsured = "";

        var horse3Name = "";
        var horse3Use = "";
        var horse3SumInsured = "";

        var horse4Name = "";
        var horse4Use = "";
        var horse4SumInsured = "";

        var horse5Name = "";
        var horse5Use = "";
        var horse5SumInsured = "";


        for (var i = 0; i < numberOfHorses; i++) {
            var horse = horses[i];
            
            if (i == 0) {
                horse1Name = horse.HorseName.trim();
                horse1Use = horse.HorseUsage.trim();
                horse1SumInsured = horse.HorseSumInsured.trim();

            }
            else if (i == 1) {
                horse2Name = horse.HorseName.trim();
                horse2Use = horse.HorseUsage.trim();
                horse2SumInsured = horse.HorseSumInsured.trim();
            }
            else if (i == 2) {
                horse3Name = horse.HorseName.trim();
                horse3Use = horse.HorseUsage.trim();
                horse3SumInsured = horse.HorseSumInsured.trim();
            }
            else if (i == 3) {
                horse4Name = horse.HorseName.trim();
                horse4Use = horse.HorseUsage.trim();
                horse4SumInsured = horse.HorseSumInsured.trim();
            }
            else if (i == 4) {
                horse5Name = horse.HorseName.trim();
                horse5Use = horse.HorseUsage.trim();
                horse5SumInsured = horse.HorseSumInsured.trim();
            }

        }
        
        // populate horse1 details
        $wrapper.find("#q10071_q1").val(horse1Name);
        $wrapper.find("#q10071_q1").blur();

        $wrapper.find("#q10071_q2").val(horse1Use);
        $wrapper.find("#q10071_q2").blur();

        $wrapper.find("#q10071_q6").val(horse1SumInsured);
        $wrapper.find("#q10071_q6").blur();

        // populate horse2 details
        $wrapper.find("#q11148_q1").val(horse2Name);
        $wrapper.find("#q11148_q1").blur();

        $wrapper.find("#q11148_q2").val(horse2Use);
        $wrapper.find("#q11148_q2").blur();

        $wrapper.find("#q11148_q6").val(horse2SumInsured);
        $wrapper.find("#q11148_q6").blur();

        // populate horse3 details
        $wrapper.find("#q14388_q1").val(horse3Name);
        $wrapper.find("#q14388_q1").blur();

        $wrapper.find("#q14388_q2").val(horse3Use);
        $wrapper.find("#q14388_q2").blur();

        $wrapper.find("#q14388_q6").val(horse3SumInsured);
        $wrapper.find("#q14388_q6").blur();

        // populate horse4 details
        $wrapper.find("#q14392_q1").val(horse4Name);
        $wrapper.find("#q14392_q1").blur();

        $wrapper.find("#q14392_q2").val(horse4Use);
        $wrapper.find("#q14392_q2").blur();

        $wrapper.find("#q14392_q6").val(horse4SumInsured);
        $wrapper.find("#q14392_q6").blur();

        // populate horse5 details
        $wrapper.find("#q14396_q1").val(horse5Name);
        $wrapper.find("#q14396_q1").blur();

        $wrapper.find("#q14396_q2").val(horse5Use);
        $wrapper.find("#q14396_q2").blur();

        $wrapper.find("#q14396_q6").val(horse5SumInsured);
        $wrapper.find("#q14396_q6").blur();

    }

    // it was identified that when pressing back 
    // browser tries to autofill previous filled in entries
    fmg.clearBrowserAutoFill = function($wrapper = $("body")) {

        // clear Digital Signature
        $wrapper.find("#q10072_q4").val("");

        // clear horse1 details browser pre-fill
        $wrapper.find("#q10071_q3_0").prop("checked", false);
        $wrapper.find("#q10071_q3_1").prop("checked", false);
        $wrapper.find("#q10071_q4").val("");
        $wrapper.find("#q10071_q5").val("");
        $wrapper.find("#q10071_q7_0").prop("checked", false);
        $wrapper.find("#q10071_q7_1").prop("checked", false);
        $wrapper.find("#q10071_q8").val("");
        $wrapper.find("#q10071_q9_0").prop("checked", false);
        $wrapper.find("#q10071_q10_0").prop("checked", false);
        $wrapper.find("#q10071_q11_0").prop("checked", false);

        // clear horse2 details browser pre-fill
        $wrapper.find("#q11148_q3_0").prop("checked", false);
        $wrapper.find("#q11148_q3_1").prop("checked", false);
        $wrapper.find("#q11148_q4").val("");
        $wrapper.find("#q11148_q5").val("");
        $wrapper.find("#q11148_q7_0").prop("checked", false);
        $wrapper.find("#q11148_q7_1").prop("checked", false);
        $wrapper.find("#q11148_q8").val("");
        $wrapper.find("#q11148_q9_0").prop("checked", false);
        $wrapper.find("#q11148_q10_0").prop("checked", false);
        $wrapper.find("#q11148_q11_0").prop("checked", false);

        // clear horse3 details browser pre-fill
        $wrapper.find("#q14388_q3_0").prop("checked", false);
        $wrapper.find("#q14388_q3_1").prop("checked", false);
        $wrapper.find("#q14388_q4").val("");
        $wrapper.find("#q14388_q5").val("");
        $wrapper.find("#q14388_q7_0").prop("checked", false);
        $wrapper.find("#q14388_q7_1").prop("checked", false);
        $wrapper.find("#q14388_q8").val("");
        $wrapper.find("#q14388_q9_0").prop("checked", false);
        $wrapper.find("#q14388_q10_0").prop("checked", false);
        $wrapper.find("#q14388_q11_0").prop("checked", false);

        // clear horse4 details browser pre-fill
        $wrapper.find("#q14392_q3_0").prop("checked", false);
        $wrapper.find("#q14392_q3_1").prop("checked", false);
        $wrapper.find("#q14392_q4").val("");
        $wrapper.find("#q14392_q5").val("");
        $wrapper.find("#q14392_q7_0").prop("checked", false);
        $wrapper.find("#q14392_q7_1").prop("checked", false);
        $wrapper.find("#q14392_q8").val("");
        $wrapper.find("#q14392_q9_0").prop("checked", false);
        $wrapper.find("#q14392_q10_0").prop("checked", false);
        $wrapper.find("#q14392_q11_0").prop("checked", false);

        // clear horse5 details browser pre-fill
        $wrapper.find("#q14396_q3_0").prop("checked", false);
        $wrapper.find("#q14396_q3_1").prop("checked", false);
        $wrapper.find("#q14396_q4").val("");
        $wrapper.find("#q14396_q5").val("");
        $wrapper.find("#q14396_q7_0").prop("checked", false);
        $wrapper.find("#q14396_q7_1").prop("checked", false);
        $wrapper.find("#q14396_q8").val("");
        $wrapper.find("#q14396_q9_0").prop("checked", false);
        $wrapper.find("#q14396_q10_0").prop("checked", false);
        $wrapper.find("#q14396_q11_0").prop("checked", false);
    
    }

    fmg.getEquineDetailsFromId = function(id) {

        var $dataAttributeEndpoint = $("[data-field-equine-renewal-endpoint]");
        var equineRenewalEndpoint = $dataAttributeEndpoint.data("field-equine-renewal-endpoint");

        var $dataAttributeRedirect = $("[data-field-equine-renewal-redirect]");
        var equineRenewalRedirect = $dataAttributeRedirect.data("field-equine-renewal-redirect");
        
        var equineRenewalurl = equineRenewalEndpoint + "/_nocache?renewalid=" + id;

        $.ajax({
            type: "GET",
            url: equineRenewalurl,
                
            success: function(response) {
                if(response !== null) {
                    try {
                        
                        var equineDetails = JSON.parse(response);
                        
                        if (equineDetails.NumberOfHorses > 0) {
                            fmg.populateEquineDetails(equineDetails);
                        }
                        else {
                            $(location).prop("href", equineRenewalRedirect);
                        }
                    }
                    catch(error) {
                        $(location).prop("href", equineRenewalRedirect);
                    }
                }
            },
            error: function() {
                $(location).prop("href", equineRenewalRedirect);
            }
        })        
    }

    // Clear text button that gets dynamically added to text inputs when user starts typing in 1 or more characters
    // Removed when user clicks on it
    fmg.formTextFieldKeyHandler = function() {

        var $this = $(this);

        var this_value = $this.val();

        var $clear_btn = "<button type='button' class='clear-input-btn' aria-label='Clear this field's text input'><svg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24'><defs><filter id='znh4ny90xa'><feColorMatrix in='SourceGraphic' values='0 0 0 0 0.999948 0 0 0 0 1.000000 0 0 0 0 0.999874 0 0 0 1.000000 0'/></filter></defs><g fill='#FFFFFF' fill-rule='evenodd'><g transform='translate(-131 -362)'><g><path fill='#1A1A1A' d='M17.303 4.075l2.122 2.122-5.304 5.302 5.304 5.304-2.122 2.122L12 13.62l-5.302 5.304-2.122-2.122L9.878 11.5 4.575 6.197l2.122-2.122 5.302 5.303 5.304-5.303z' transform='translate(131 362)'/></g></g></g></svg></button>";

        // If input has text
        if(this_value.length && !$this.hasClass('form__input-has-text')) {
            $this.addClass('form__input-has-text');
            $this.after($clear_btn);
        }

        else if(!this_value.length && $this.hasClass('form__input-has-text')) {
            $this.removeClass('form__input-has-text');
            $this.siblings(".clear-input-btn").remove();
        }

    };

    fmg.setupClearTextInputBtn = function() {
        // Event to handle dynamically added clear text input button
        $('body').on('click', '.clear-input-btn', fmg.formClearInputBtnHandler);
    }

    // Event handler to clear input and remove clear input button when clear input button is clicked
    fmg.formClearInputBtnHandler = function(event) {

        var $this = $(this);
        var $sibling_input = $this.siblings("input, textarea");

        $sibling_input.removeClass("form__input-has-text");
        $sibling_input.val('');
        $sibling_input.trigger("focus");

        if($sibling_input.is("[data-field-address]")) {
            fmg.resetAddressSuggestions();
        }

        $this.remove();

        event.stopPropagation();

    };

    // Setup text fields (Text, email, number, tel, textarea)
    // Add base class and specific type class to field labels
    // Setup focus / blur / keyup events

    // The argument can be a jquery object to define a specific area
    // Without a param supplied, the default is the whole body
    fmg.setupTextFields = function($wrapper = $("body")) {

        // Don't initiate this on text fields that have data-month-selector attribute. Thats for month selector flatpickr plugin
        $wrapper.find('[type="text"], [type="email"], [type="number"], [type="tel"], textarea').not("[data-month-selector], [data-equine-renewal-account]").each(function() {

            var $this_text_field = $(this);

            var id = $this_text_field.prop("id");

            // Need to use prop instead of attr so that textarea can be identified
            var type = $this_text_field.prop("type");

            var $this_text_label = $("label[for='" + id + "']");

            $this_text_label.addClass('form__label');

            // Setup label class
            if (type === "textarea") {
                $this_text_label.addClass('form__label--type-textarea');
            } else {
                $this_text_label.addClass('form__label--type-text');
            }

            $this_text_field.on("focus", function() {
                $this_text_label.addClass("form__label--active-true");                
            });

            $this_text_field.on("blur", function() {

                var $this_text_value = $this_text_field.val();

                if ($this_text_value.length) {
                    // Trigger blur is needed if field has default value when page loads
                    $this_text_label.addClass("form__label--active-true");
                } else {      
                    $this_text_label.removeClass("form__label--active-true");
                }
                
            }).trigger("blur");

            $this_text_field.on('keyup', fmg.fn.debounce(fmg.formTextFieldKeyHandler, 50)).trigger("keyup");
  
        });

        $wrapper.find("[data-equine-renewal-account]").each(function() {
            
            var $this_text_field = $(this);
            $this_text_field.addClass("equine-renewal-account-input-text");
            $this_text_field.attr("readonly", "");

            var id = $this_text_field.prop("id");

            var $this_text_label = $("label[for='" + id + "']");
            $this_text_label.addClass("equine-renewal-account-input-title");
            $this_text_label.parent().addClass("equine-renewal-account");
        });

    }

    // Setup search fields (type="search")
    fmg.setupSearchFields = function($wrapper = $("body")) {

        $wrapper.find('[type="search"]').each(function() {

            var $this_search_field = $(this);

            $this_search_field.on('keyup', fmg.fn.debounce(fmg.formTextFieldKeyHandler, 50)).trigger("keyup");

        });
        
    }
    
    // Setup select fields
    // Add base label class and specific select class
    // Setup focus / blur / hover events
    fmg.setupSelectFields = function($wrapper = $("body")) {

        $wrapper.find("select").each(function() {
        
            var $this_select_field = $(this);
            
            if ($this_select_field.is("[data-exclude-global-setup]")) {
                
                $this_select_field.on("change", function() {
                    
                    var this_select_value = $this_select_field.val();
                    
                    if (this_select_value !== "0") {
                        $this_select_field.addClass("form__select-changed");
                    } else {
                        $this_select_field.removeClass("form__select-changed");
                    }
                    
                }).trigger("change");

            } else {

                var id = $this_select_field.prop("id");

                // Setup label
                var $this_select_label = $("label[for='" + id + "']");
            
                $this_select_label.addClass('form__label form__label--type-select');

                // Set up focus / hover events so that when user focuses / hovers over, hover class is added to the label
                $this_select_field.on("focus", function() {

                    $this_select_label.addClass("form__label--active-true");

                }).on("blur", function() {

                    var $this_select_value = $this_select_field.val();

                    if ($this_select_value.length) {
                        // Trigger blur is needed if field has default value when page loads
                        $this_select_label.addClass("form__label--active-true");
                    } else {      
                        $this_select_label.removeClass("form__label--active-true");
                    }

                });

                $this_select_field.on("mouseenter", function() {

                    $this_select_label.addClass("form__label--hover-true");

                }).on("mouseleave", function() {

                    $this_select_label.removeClass("form__label--hover-true");

                });
            
                // Change event when the user has selected a value
                // trigger("change") is for the scenario if the form is loaded with a default value
                $this_select_field.on("change", function() {

                    var this_select_value = $this_select_field.val();

                    if (this_select_value !== "") {
                        $this_select_field.addClass("form__select-changed");
                        $this_select_label.addClass("form__label--active-true");                        
                    } else {
                        $this_select_field.removeClass("form__select-changed");
                        $this_select_label.removeClass("form__label--active-true");
                    }
            
                }).trigger("change");

            }

        });

    }

    // Setup date time fields
    // Initiate flatpickr plugin
    fmg.setupDatetimeFields = function($wrapper = $("body")) {

        // The argument can either be an integer (e.g. 10 means 10 days from now) vs 18-02-21 or 18th Feburary 2021
        function getRangeDate(date_range) {

            var date;

            if (!isNaN(date_range)) {

                // If supplied min_date_range is a number
                date = new Date().fp_incr(date_range);

            } else {
                
                // If supplied date is a string, lets see what trying to make a date object with it looks like
                date = new Date(date_range);

            }

            if (!(date instanceof Date && !isNaN(date))) {
                
                // Final result is not a date
                // Set to default of null
                date = null;

            }
    
            return date;

        }

        // Setup label
        $wrapper.find("input[type='date'], input[type='datetime-local']").each(function() {

            var $this_date_field = $(this);

            // Need to use .attr here because in safari, prop("type") on date fields would result in "text", not "date" or "datetime-local"
            var type = $this_date_field.attr("type");

            var id = $this_date_field.prop("id");

            // Set min/max dates
            var min_date = getRangeDate($this_date_field.data("min-date-range"));
            var max_date = getRangeDate($this_date_field.data("max-date-range"));

            // Setup label
            var $this_date_label = $("label[for='" + id + "']");
            
            $this_date_label.addClass('form__label form__label--type-date');

            // If this date field already has a value when form is loaded
            if ($this_date_field.val().length) {
                $this_date_label.addClass("form__label--focused-true");
            }

            if (type === "date") {

                $this_date_field.flatpickr({

                    altInput: true,
                    altFormat: "d/m/Y",
                    dateFormat: "Y-m-d",
                    maxDate: max_date,
                    minDate: min_date,
                    monthSelectorType: "static",
                    clickOpens: false, 
                    locale: {
                        weekdays: {
                        shorthand: ["S", "M", "T", "W", "T", "F", "S"]
                        }
                    },
        
                    // Add ID to avoid jQuery validate console errors
                    onReady: function(selectedDates, dateStr, instance) {
        
                        var id = instance.element.id;
        
                        var $alt_input = $('input[id="' + id + '"]').next();
        
                        var faux_id = id + "-datepicker" ;
        
                        $alt_input.prop("id", faux_id);
                        $alt_input.prop("name", faux_id);
        
                    },
                    // Handles adding the focused classes to the labels
                    onOpen: function(selectedDates, dateStr, instance) {
                                    
                        $this_date_label.addClass('form__label--focused-true');
        
                    },
                    onChange: function(selectedDates, dateStr, instance) {

                        var $month_container = $(instance.rContainer);
                        
                        // If no date is selected
                        if (selectedDates.length) {
                
                            $this_date_label.addClass('form__label--focused-true');

                            $month_container.addClass("date-selected");
        
                        } else {

                            $this_date_label.removeClass('form__label--focused-true');

                            $month_container.removeClass("date-selected");
                            
                        }

                    },
                    onClose: function(selectedDates, dateStr, instance) {
        
                        // If no date is selected
                        if (!selectedDates.length) {
                
                            $this_date_label.removeClass('form__label--focused-true');
        
                        }
                        
                    }
        
                });

            } else {

                $this_date_field.flatpickr({

                    altInput: true,
                    altFormat: "d/m/Y",
                    dateFormat: "Y-m-d",
                    maxDate: max_date,
                    minDate: min_date,
                    monthSelectorType: "static",
                    clickOpens: false, 
                    locale: {
                        weekdays: {
                        shorthand: ["S", "M", "T", "W", "T", "F", "S"]
                        }
                    },
                    enableTime: true,
                    altFormat: "h:iK d/m/Y",
                    dateFormat: "Y-m-dTH:i",
        
                    // Add ID to avoid jQuery validate console errors
                    onReady: function(selectedDates, dateStr, instance) {
        
                        var id = instance.element.id;
        
                        var $input = $('input[id="' + id + '"]');
        
                        var $alt_input = $input.next();
        
                        var faux_id = id + "-datepicker" ;
        
                        $alt_input.prop("id", faux_id);
                        $alt_input.prop("name", faux_id);
        
                    },
                    // Handles adding the focused classes to the labels
                    onOpen: function(selectedDates, dateStr, instance) {
                                    
                        $this_date_label.addClass('form__label--focused-true');
        
                    },
                    onClose: function(selectedDates, dateStr, instance) {
        
                        // If no date is selected
                        if (!selectedDates.length) {
                
                            $this_date_label.removeClass('form__label--focused-true');
        
                        }
                        
                    },
                    onChange: function(selectedDates, dateStr, instance) {

                        var $month_container = $(instance.rContainer);
                        
                        // If no date is selected
                        if (selectedDates.length) {

                            $month_container.addClass("date-selected");
        
                        } else {

                            $month_container.removeClass("date-selected");
                            
                        }

                    },
        
                });

            }

            // Toggle calendar display
            $("#" + id + "-datepicker").on("click", function(ev) {

                var $actual_input = $(this).prev();

                if ($actual_input[0]._flatpickr.isOpen) {

                  $actual_input[0]._flatpickr.close();

                } else {

                 $actual_input[0]._flatpickr.open();

                }

            });

        });

        // Handle flatpickr mobile version
        // You will notice that when chrome inspect tools are open, the flatprickr creates a "mobile native datepicker" field but can't be interacted in
        // However, we still want the label focus classes for real mobile devices
        $wrapper.find(".flatpickr-mobile").on("focus", function(event) {

            var $this_date_field = $(event.target);

            var $this_date_label = $("label[for='" + $this_date_field.prop("id").replace("-datepicker","") + "']");

            $this_date_label.addClass("form__label--focused-true");

        });
        
        $wrapper.find(".flatpickr-mobile").on("blur", function(event) {

            var $this_date_field = $(event.target);
            
            var $this_date_label = $("label[for='" + $this_date_field.prop("id").replace("-datepicker","") + "']");

            if ($this_date_field.val().length) {
                $this_date_label.addClass("form__label--focused-true");
            } else {
                $this_date_label.removeClass("form__label--focused-true");
            }

        });

        // Focus / Blur are not enough. Need this to account for Chrome's "Clear" button in the calendar
        $wrapper.find(".flatpickr-mobile").on("change", function(event) {

            var $this_date_field = $(event.target);
            
            var $this_date_label = $("label[for='" + $this_date_field.prop("id").replace("-datepicker","") + "']");

            if ($this_date_field.val().length) {
                $this_date_label.addClass("form__label--focused-true");
            } else {
                $this_date_label.removeClass("form__label--focused-true");
            }

        }).trigger("change");

    }

    // Set up month selector with flatpickr month plugin
    fmg.setupMonthPickerFields = function($wrapper = $("body")) {

        $wrapper.find("[data-month-selector]").each(function() {

            var $this_date_field = $(this);

            var id = $this_date_field.prop("id");

            // Setup label
            var $this_date_label = $("label[for='" + id + "']");
            
            $this_date_label.addClass('form__label form__label--type-date');

            // If this date field already has a value when form is loaded
            if ($this_date_field.val().length) {
                $this_date_label.addClass("form__label--focused-true");
            }

            var today = new Date();
            
            var this_month = new Date(today.getFullYear(), today.getMonth(), 1);

            var next_year = new Date().setFullYear(new Date().getFullYear() + 1);

            $this_date_field.flatpickr({

                altInput: true,
                minDate: this_month,
                maxDate: next_year,
                disableMobile: true,
                clickOpens: false, 
                static: true,
                plugins: [
                    new monthSelectPlugin({
                        shorthand: true, // Months are displayed as Jan, Feb, Mar etc
                        dateFormat: "Y-m", // Real value stored in hidden field
                        altFormat: "M y" // Show on front end
                    })
                ],

                // Add ID to avoid jQuery validate console errors
                onReady: function(selectedDates, dateStr, instance) {
        
                    var id = instance.element.id;
    
                    var $input = $('input[id="' + id + '"]');
    
                    var $alt_input = $input.next();
    
                    var faux_id = id + "-datepicker" ;
    
                    $alt_input.prop("id", faux_id);
                    $alt_input.prop("name", faux_id);
                    $alt_input.attr('data-current-month', $alt_input.val());
    
                },

                onOpen: function(selectedDates, dateStr, instance){

                    $this_date_label.addClass('form__label--focused-true');

                    // Add class only if user is looking at the same year as the selected date year
                    // Remove if not
                    if (selectedDates.length) {
                           
                        if (instance.currentYear == new Date(selectedDates).getFullYear()) {
                            $(instance.calendarContainer).addClass("viewing-selected-year")
                        } else {
                            $(instance.calendarContainer).removeClass("viewing-selected-year")
                        }

                    }

                },
    
                onYearChange: function(selectedDates, dateStr, instance){
                    
                    // Without this the month picker shows the previous year arrow
                    var $prev_year_btn = $(instance.prevMonthNav);

                    var $next_year_btn = $(instance.nextMonthNav);

                    if (instance.currentYear == today.getFullYear()){
                        $prev_year_btn.addClass('flatpickr-disabled');
                        $next_year_btn.removeClass('flatpickr-disabled');
                    } 
                    
                    else if (instance.currentYear == (today.getFullYear() + 1)) {
                        $next_year_btn.addClass('flatpickr-disabled');
                        $prev_year_btn.removeClass('flatpickr-disabled');
                    } 
                    
                    else {
                        $prev_year_btn.removeClass('flatpickr-disabled');
                    }

                    // Add class only if user is looking at the same year as the selected date year
                    $(instance.calendarContainer).removeClass("viewing-selected-year")

                    // Remove if not
                    if (selectedDates.length && (instance.currentYear == new Date(selectedDates).getFullYear())) {
                        $(instance.calendarContainer).addClass("viewing-selected-year")    
                    }

                },

                onChange: function(selectedDates, dateStr, instance) {

                    var selected_date = new Date(selectedDates);

                    var $prev_year_btn = $(instance.prevMonthNav);

                    var $next_year_btn = $(instance.nextMonthNav);
                    
                    var id = instance.element.id;
    
                    var $input = $('input[id="' + id + '"]');
    
                    var $alt_input = $input.next();

                    // Without this the month picker shows the previous year arrow
                    if(selected_date.getFullYear() == today.getFullYear()){

                        $prev_year_btn.addClass('flatpickr-disabled');
                        $next_year_btn.removeClass('flatpickr-disabled');

                    }

                    if(selected_date.getFullYear() == today.getFullYear() + 1){

                        $next_year_btn.addClass('flatpickr-disabled');
                        $prev_year_btn.removeClass('flatpickr-disabled');

                    }

                    if($alt_input.data('current-month') == $alt_input.val()){
                        
                        // If both values are not blank
                        if(!$alt_input.data('current-month') == '' && !$alt_input.val() == ''){
                            
                            $input[0]._flatpickr.clear();

                            setTimeout(function(){
                                var $selected_month = $(".flatpickr-monthSelect-month.selected");
                                $selected_month.removeClass("selected");
                            },1000)   

                        }
                    }

                    else {
                        $alt_input.data("current-month", $alt_input.val());
                    }

                },

                onClose: function(selectedDates, dateStr, instance) {
    
                    // If no date is selected
                    if (!selectedDates.length) {
            
                        $this_date_label.removeClass('form__label--focused-true');
    
                    }
                    
                }
    
            });
            
             // Toggle calendar display
            $("#" + id + "-datepicker").on("click", function(ev) {

                var $actual_input = $(this).prev();


                if ($actual_input[0]._flatpickr.isOpen) {

                  $actual_input[0]._flatpickr.close();

                } else {

                 $actual_input[0]._flatpickr.open();

                }

            });

        });
        
    }
    
    fmg.setupAddressFields = function($wrapper = $("body")) {

        var $listbox = "";
        var $use_this_address = "";
        
        var $addressFields = $wrapper.find("[data-field-address]");
        
        if ($addressFields.length > 0) {
                        
            $(document).on("click", function(event) {
                var $clickedItem = $(event.target);

                if($clickedItem.is("li.addressSuggestion")) {
                  var chosenAddress = $clickedItem.text();
                  $clickedItem.parent().siblings("input").val(chosenAddress);
                  $wrapper.find(".address-validation").find('input[value="0"]').prop("checked", true);
                  fmg.resetAddressSuggestions(true, true, false);
                  
                  // focus then blur to trigger validation
                  $addressFields[0].focus();
                  $addressFields[0].blur();

                } else if ($clickedItem.is("#useThisAddress") || $clickedItem.is(".useThisAddressLabel")) {
                    $wrapper.find(".address-validation").find('input[value="1"]').prop("checked", true);
                    fmg.resetAddressSuggestions(true, false, false, true);
                    // focus then blur to trigger validation
                    $addressFields[0].focus();
                    $addressFields[0].blur();
                    
                } else if ($clickedItem.parent().is(".no-result--address-suggestion")) {
                    //do nothing - do not hide
                } else {
                    if (!$use_this_address.hasClass("hidden")) {                        
                        $addressFields[0].focus();
                        $addressFields[0].blur();
                        $clickedItem.focus();
                    }
                    fmg.resetAddressSuggestions(true, false, false);                    
                }            
            });
        }

        $addressFields.each(function() {
            var $this_address_field = $(this);

            // add parent div attributes
            var $parentDiv = $this_address_field.parent();
            $parentDiv.attr("role", "combobox");
            $parentDiv.attr("aria-owns", "address-listbox");
            $parentDiv.attr("aria-haspopup", "listbox");
            $parentDiv.attr("aria-expanded", "false");

            // add input attributes
            $this_address_field.attr("aria-autocomplete", "list");
            $this_address_field.attr("aria-controls", "address-listbox");
            $this_address_field.attr("aria-activedescendant", "");
            
            // add siblings - listbox
            $this_address_field.after($("<ul></ul>")
                .addClass("listbox")
                .addClass("hidden")
                .attr("role", "listbox")
                .attr("id", "address-listbox")
            );
            
            $listbox = $this_address_field.siblings(".listbox");

            // add siblings - use this address box
            $listbox.after($("<div></div>")
                .addClass("no-result--address-suggestion")
                .addClass("hidden")
                .append($("<div></div>")
                    .html("Sorry, we couldn't find a match. Please check the spelling and that the address has been entered correctly. <br>" + 
                        "If this is the right address tick the box below<br><br>")
                    .append($("<input/>")
                        .attr("type", "checkbox")
                        .attr("id", "useThisAddress")
                    )
                    .append($("<label></label>")
                        .addClass("useThisAddressLabel")
                        .attr("for", "useThisAddress")
                        .text("Yes, I want to use this address")
                    )
                )                
            );

            $use_this_address = $this_address_field.siblings(".no-result--address-suggestion");
            
            $this_address_field.on("input", fmg.fn.debounce(fmg.getAddressSuggestions, 500));            

            $use_this_address.on("keydown", function(event) {
                switch (event.key) {
                    case "Tab":
                        $this_address_field.focus();                        
                        fmg.resetAddressSuggestions(true, false, false);
                        break;

                    default:
                        break;
                }
            })

            $this_address_field.on("keydown", function(event) {

                var prevIndex = -1;
                var newIndex = 0;
                var lastResultIndex = $listbox.attr("data-last-result-index");
                
                switch (event.key) {
                    case "Up":
                    case "ArrowUp":
                        event.preventDefault();
                        
                        if (lastResultIndex >= 0) {
                            var aria_activedescendant = $this_address_field.attr("aria-activedescendant");
                            
                            if (aria_activedescendant === "") {
                                newIndex = lastResultIndex;
                            } else {
                                prevIndex = parseInt(aria_activedescendant.replace("address-option-", ""), 10);
                                if (prevIndex > 0) {
                                    newIndex = prevIndex - 1;
                                } else {
                                    newIndex = lastResultIndex;
                                }                                
                            }                             
                            fmg.setHighlightedItem(prevIndex, newIndex);                        
                        }

                        break;
                    
                    case "Down":
                    case "ArrowDown":
                        event.preventDefault();
                        
                        if (lastResultIndex >= 0) {
                            var aria_activedescendant = $this_address_field.attr("aria-activedescendant");
                            
                            prevIndex = parseInt(aria_activedescendant.replace("address-option-", ""), 10);
                            if (prevIndex < lastResultIndex) {
                                newIndex = prevIndex + 1;
                            }                                
                                                         
                            fmg.setHighlightedItem(prevIndex, newIndex);                        
                        }
                        break;
                        
                    case "Enter":
                        event.preventDefault();
                    
                    case "Tab":
                        if($listbox.children().length > 0) {
                            var aria_activedescendant = $this_address_field.attr("aria-activedescendant");                            
                            var selectedIndex = parseInt(aria_activedescendant.replace("address-option-", ""), 10);
                            if (selectedIndex >= 0) {
                                fmg.setSelectedItem($this_address_field, selectedIndex);
                                fmg.resetAddressSuggestions(true, true, false);
                            }                            
                        } else if (!$use_this_address.hasClass("hidden")) {
                            $use_this_address.find("input").focus();
                            event.preventDefault();
                        }

                        break;
                    
                    case "Escape":
                        event.preventDefault();
                        fmg.resetAddressSuggestions();                        
                        break;
                    
                    default:
                        break;
                }
            });
        });
    }    

    fmg.setupFileInputs = function($wrapper = $("body")) {
       
        $wrapper.find('input[data-file-input]').each(function (ind, elem) {

            var $this_file_input = $(this);

            var $file_input_wrapper = $this_file_input.closest(".sq-form-upload-wrapper");
            
            var clear_input_btn = '<button type="button" title="Delete" class="sq-form-upload-delete-button form__delete-file-btn">Remove</button>';

            var clear_input_btn_class = ".form__delete-file-btn";

            // Append delete button
            $this_file_input.after(clear_input_btn);


            // Clear first input 
            $wrapper.on("click", clear_input_btn_class, function(e) {

                if($this_file_input.val() != '' || $this_file_input.val() != null) {

                    $this_file_input.val('');

                    $this_file_input.valid();

                }

            });
          
            $wrapper.on("change", "input[type=file]", function() {

                $(this).valid();

            });

            var file_deletion_observer = new MutationObserver(function(mutations){

                var $file_input_fields = $file_input_wrapper.find("input[type=file]");

                mutations.forEach(function(mutation){

                    if (mutation.type === 'childList') {

                        $file_input_fields.valid();

                    }

                });

            });

            file_deletion_observer.observe($file_input_wrapper[0], {childList: true});
    
        });
    
    }

    fmg.setupDataDependentOnly = function() {
        var $dataAttributeDependendentOnly = $("[data-dependent-only]");
        var dependentOnly = $dataAttributeDependendentOnly.data("dependent-only");

        if(dependentOnly) {
            var question = Object.keys(dependentOnly)[0];
            var answer = Object.values(dependentOnly)[0];

            var inputName = "input[name='" + question + "[]']";
            
            $(inputName).on("click", function() {
                fmg.updateCheckedOptions(inputName, answer);
            })
        }
    }

    fmg.updateCheckedOptions = function(inputName, answer) {
        var $options = $(inputName);
        
        var checkedOptions = $options.filter(':checked');

        if (checkedOptions.length === 1) {
            var tickedValue = checkedOptions.attr('value');
            fmg.toggleFMGConnectBlock(tickedValue === answer);
        } else {
            fmg.toggleFMGConnectBlock(false);
        }
    }

    fmg.toggleFMGConnectBlock = function(shouldShow) {
        if(shouldShow) {
            $(".connect-block").removeClass("hidden");
        } else {
            $(".connect-block").addClass("hidden");
        }        
    }

    fmg.setupEquineRenewalForm = function() {
        var $dataAttributeRedirect = $("[data-field-equine-renewal-redirect]");
        var equineRenewalRedirect = $dataAttributeRedirect.data("field-equine-renewal-redirect");
        
        var urlParams = new URLSearchParams(window.location.search);
        var id = urlParams.get("id");

        if(urlParams !== null) {
            if (id !== null && id !== "") {
                fmg.getEquineDetailsFromId(id);
            }
            else {
                $(location).prop("href", equineRenewalRedirect);
            }
        }
        else {
            $(location).prop("href", equineRenewalRedirect);
        }
    }

    fmg.getInputLabel = function(input) {

        // Replace "-datepicker" is needed because the flatpickr plugin makes a hidden input field with the real id and name value to store the real format while a "faux text field" is created to show the "alternative input". e.g., the hidden input field needs to store YYYY-MM-DD while the alt input shows DD-MM-YYYY
        // Initially, they have no id or name so onReady, I gave them matrix id + "-datepicker"
        // But in order to find the label, i need to remove the substring "-datepicker"
        var $label = $("label[for='" + input.id.replace("-datepicker","") + "']");

        if ($label.length) {

            return $label.text().toLowerCase();
            
        } else {

            return false;

        }

    }

    // This function adds the aria-live attribute to all form fields wrapper
    fmg.addAriaLiveAttribute = function ($wrapper = $("body")) {

        var $field_wrappers = $wrapper.find(".sq-form-question-answer");

        if ($field_wrappers.length) {

            $field_wrappers.each(function(index, field_wrapper) {

                var $this_field_wrapper = $(field_wrapper);

                $this_field_wrapper.attr("aria-live", "polite");

            });

        }

    }

    // This function adds a class to all labels of fields which are required
    fmg.addAsteriskToLabels = function($wrapper = $("body")) {

        // Get all required text inputs, textareas, select
        var $required_inputs = $wrapper.find("input[type='text'], input[type='email'], input[type='tel'], input[type='number'], input[type='date'], input[type='datetime-local'], textarea, select").filter("[required]");

        var $required_radio_checkboxes = $wrapper.find("input[type=radio], input[type=checkbox]").filter("[required]").toArray();

        var $filtered_radio_checkboxes = fmg.fn.distinctArrayBy($required_radio_checkboxes, "name");

        if ($required_inputs.length) {

            $required_inputs.each(function(index, input) {

                var $this_input = $(input);

                var this_input_id = $this_input.attr('id');

                var $label = $("label[for='" + this_input_id + "']");

                if ($label.length) {

                    $label.addClass("form__label-required");

                }

            });

        }

        if ($filtered_radio_checkboxes.length) {

            $filtered_radio_checkboxes.forEach(function(input){
            
                var $this_input = $(input);

                var $question_title = $this_input.closest(".sq-form-question").find(".sq-form-question-title");


                if ($question_title.length) {

                    $question_title.addClass("form__label-required");

                }

            })

        }

    }

    fmg.formErrorMessage = function(text) {
        
        var $error_element = `<span class="form__error">${text}</span>`;

        return $error_element;
    }

    fmg.formValidationCustomMethods = function() {

        $.validator.addMethod("phone_regex", function(value, input) {

            // Regex to match phone numbers only
            if (/^(\+)?([ 0-9]){7,17}$/.test(value)) {
                return true;
            }  else {
                return false;
            }

        });

        $.validator.addMethod('file_size', function (value, element, param) {
            
            var maxCombined = param * 1000000;
            
            var currCombined = 0;


            $('input[data-file-input]').each(function() {

                if(!this.files) {
                    return false;

                } else if(typeof this.files[0] !== 'undefined' && (typeof this.files[0].size !== 'undefined' || this.files[0].size !== 'null')) {

                    currCombined += this.files[0].size;

                }

            });
            
            if(currCombined >= maxCombined && currCombined !== 0) {

                return false;

            } else {

                return true;

            }

        });

        $.validator.addMethod('file_extension', function (value, file_input_element, param) {
            
            param = typeof param === "string" ? param.replace(/,/g, "|") : "png|jpe?g|gif";

            var $file_input_element = $(file_input_element);

            var file_input_element_name = $file_input_element.attr("name");

            var isValidated = true;

            $("[name='" + file_input_element_name + "']").each(function() {
                
                if (this.files.length) {

                    var filename = this.files[0].name;

                    if (!filename.match(new RegExp(".(" + param + ")$", "i"))) {
                        isValidated = false;
                        return false; // Break the each loop
                    }

                }
                    
            });

            return isValidated;
            
        });

        $.validator.addMethod("no_digits", function(value, element) {
            return this.optional(element) || /^([^0-9]*)$/i.test(value);
        });

        $.validator.addMethod("currency_custom", function (value, element) {
            return this.optional(element) || /^\$?(\d{1,3}(\,\d{3})*|(\d+))(\.\d{2})?$/.test(value);
        });

        $.validator.addMethod("dd_mm_yyyy", function (value, element) {
            return this.optional(element) || /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(value);
        });

        $.validator.addMethod("valid_address", function(value, element) {
            return this.optional(element) || fmg.isAddressValidated();
        })

    }

    
    fmg.formValidationCustomRules = function($wrapper = $("body")) {
        
        $wrapper.find('input[type="tel"]').each(function(){

            $(this).rules("add", {phone_regex:true});

        });

        $wrapper.find("input[data-file-input]").each(function(){
            
            $(this).rules("add", {
                // file type restrictions in the following order:
                // jpeg, jpg, bmp, raw, png, vsd, doc, docx, pdf, gif
                file_extension: "jpeg|jpg|bmp|raw|png|vsd|doc|docx|pdf|gif"
            
            });

            $(this).rules("add", {    
                // File size 18mb
                file_size: 18
            });

        });
        
        $wrapper.find("[data-field-address]").each(function() {
        
            $(this).rules("add", {valid_address:true});
        
        })


    }

    fmg.formValidationCustomMessages = function() {

        $.validator.messages.required = function (param, input) {

            var type = input.type;
            var name = input.name;

            var required_message = "Please enter a valid input";
            
            if (type === "radio" || type === "select-one" || type === "select") {

                required_message = "Please select an option";

            } else if (type === "checkbox") {
                
                if (input.hasAttribute("data-equine-declaration")) {
                    required_message = "Please confirm";
                }
                else if ($("[name='" + name + "']").length > 1) {
                    required_message = "Please select at least one option";
                } else {
                    required_message = "Please confirm";
                }
                
            } else if (type === "textarea") { 
                required_message = "Please provide details";

            } else {

                var label = fmg.getInputLabel(input)

                if (label) {
                    required_message = "Please enter a valid " + label;
                }

            }

            return required_message;

        }

        $.validator.messages.email = function (param, input) {

            var required_message = "Please enter a valid email";

            var label = fmg.getInputLabel(input)

            if (label) {
                required_message = "Please enter a valid " + label;
            }

            return required_message;

        }

        $.validator.messages.minlength = function (param, input) {

            var required_message = "Please enter a valid input";

            var label = fmg.getInputLabel(input)

            if (label) {
                required_message = "Please enter a valid " + label;
            }

            return required_message;

        }

        $.validator.messages.maxlength = function (param, input) {

            var required_message = "Please enter a valid input";

            var label = fmg.getInputLabel(input)

            if (label) {
                required_message = "Please enter a valid " + label;
            }

            return required_message;

        }

        $.validator.messages.digits = function (param, input) {

            var required_message = "Please enter a valid input";

            var label = fmg.getInputLabel(input)

            if (label) {
                required_message = "Please enter a valid " + label;
            }

            return required_message;

        }

        // This custom method was defined in formValidationMethods
        $.validator.messages.phone_regex = function (param, input) {

            var required_message = "Please enter a valid input";

            var label = fmg.getInputLabel(input)

            if (label) {
                required_message = "Please enter a valid " + label;
            }

            return required_message;

        }

        // This custom method was defined in formValidationMethods
        $.validator.messages.no_digits = function (param, input) {
            
            var required_message = "Please enter a valid input";

            var label = fmg.getInputLabel(input)

            if (label) {
                required_message = "Please enter a valid " + label;
            }

            return required_message;

        }

        // This custom method was defined in formValidationMethods
        $.validator.messages.currency_custom = function (param, input) {
            
            var required_message = "Please enter a valid input";

            var label = fmg.getInputLabel(input)

            if (label) {
                required_message = "Please enter a valid " + label;
            }

            return required_message;

        }

        // This custom method was defined in formValidationMethods
        $.validator.messages.dd_mm_yyyy = function (param, input) {
            
            var required_message = "Please enter a valid input";

            var label = fmg.getInputLabel(input)

            if (label) {
                required_message = "Please enter a valid " + label;
            }

            return required_message;

        }

        // This custom method was defined in formValidationMethods
        $.validator.messages.valid_address = function (param, input) {
            
            var required_message = "Please enter a valid input";

            var label = fmg.getInputLabel(input)

            if (label) {
                required_message = "Please enter a valid " + label;
            }
            return required_message;

        }
        
        // This custom method was defined in formValidationMethods
        $.validator.messages.file_size = function (param, input) {
    
            var required_message = "You have exceeded the total file size";

            return required_message;

        }

        $.validator.messages.file_extension = function (param, input) {

            var required_message = "One or more of your attachments isn't an accepted file type";

            return required_message;

        }

    }

    // Validate Matrix Custom Form
    fmg.formValidation = function($wrapper = $("body")) {
        
        var $forms = $wrapper.find('form[id^="form_email_"]');

        $forms.each(function(){

            var $this = $(this);

            $this.validate({

                // I don't want jQuery validate to focus on the last field I had focus on
                focusInvalid: false,
            
                // On invalid validation, always scroll to the first one with error
                invalidHandler: function(event, validator) {
                    
                    var $first_field_with_error = $(validator.errorList[0].element);

                    $("html,body").animate({
                        scrollTop: $first_field_with_error.offset().top - 120
                    });
                    
                },
                
                errorPlacement: function(error, element) {
    
                    var $error_element = fmg.formErrorMessage(error.text());
    
                    if (element.attr("type") == "checkbox" || element.attr("type") == "radio") {
                        element.addClass("form__input-error");
                        $($error_element).insertAfter(element.closest(".sq-form-question-answer"));
                    }

                    else if ($(element).attr("type") == "file") {
                        element.closest(".sq-form-upload-wrapper").addClass("form__input-error");
                        $($error_element).insertAfter(element.closest(".sq-form-upload-wrapper"));
                    }
    
                    else {
                        element.addClass("form__input-error");
                        $($error_element).insertAfter(element);
                        
                    }
                },
    
                highlight: function(element) {
    
                    if ($(element).attr("type") == "checkbox" || $(element).attr("type") == "radio") {
                        $(element).closest("ul").addClass("form__input-error");
                        $(element).closest(".sq-form-question").find(".form__error").remove();
                    }

                    else if ($(element).attr("type") == "button") {
                        return;
                    }

                    else if ($(element).attr("type") == "file") {
                        $(element).closest(".sq-form-upload-wrapper").addClass("form__input-error");
                        $(element).closest(".sq-form-question-file-upload").find(".form__error").remove();
                    }
    
                    else {  
                        $(element).addClass("form__input-error");
                        $(element.form).find("label[for=" + element.id.replace("-datepicker","") + "]").addClass("form__label-error");
                        $(element).siblings(".form__error").remove();
                    }
    
    
                },
    
                unhighlight: function(element) {
    
                    if ($(element).attr("type") == "checkbox" || $(element).attr("type") == "radio") {
                        $(element).closest("ul").removeClass("form__input-error");
                        $(element).closest(".sq-form-question").find(".form__error").remove();
                    }

                    else if ($(element).attr("type") == "button") {
                        return;
                    }

                    else if ($(element).attr("type") == "file") {
                        $(element).closest(".sq-form-upload-wrapper").removeClass("form__input-error");
                        $(element).closest(".sq-form-question-file-upload ").find(".form__error").remove();
                    }
    
                    else {  
                        $(element).removeClass("form__input-error");
                        $(element).siblings(".form__error").remove();
                        $(element.form).find("label[for=" + element.id.replace("-datepicker","") + "]").removeClass("form__label-error");
                    }
    
                }
    
            });

        })

    }

    fmg.forms = function() {

        function init() {
            
            fmg.addAriaLiveAttribute();
            fmg.addAsteriskToLabels();
            fmg.setupClearTextInputBtn();

            fmg.setupTextFields();
            fmg.setupSearchFields();
            fmg.setupSelectFields();
            fmg.setupDatetimeFields();
            fmg.setupMonthPickerFields();
            fmg.setupFileInputs();
            fmg.setupAddressFields();
            fmg.setupEquineRenewalForm();
            fmg.setupDataDependentOnly();

            
            // Validation
            fmg.formValidation();
            fmg.formValidationCustomMethods();
            fmg.formValidationCustomMessages();
            fmg.formValidationCustomRules();

            // Setup custom rules for embedded forms
            fmg.formEmbed.init();

        }

        return {
            init: init
        };

    }();

    document.addEventListener("DOMContentLoaded", function () {
        fmg.forms.init();
    });

}());